import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Badge } from "@/components/ui/badge";

export default function ClientSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      data-testid="client-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12" ref={ref}>
        {/* Executive Summary */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="max-w-3xl"
        >
          <Badge
            data-testid="exec-summary-badge"
            className="mb-4 bg-[#4B4DF7]/8 text-[var(--sv-primary)] border-[#4B4DF7]/20 hover:bg-[#4B4DF7]/8 font-medium text-xs tracking-wide uppercase px-3 py-1"
          >
            Contesto
          </Badge>
          <h2
            data-testid="exec-summary-title"
            className="font-['Inter_Tight'] text-2xl md:text-3xl font-bold tracking-tight text-[var(--sv-secondary)] mb-4"
          >
            Il contesto del progetto
          </h2>
          <p
            data-testid="exec-summary-text"
            className="text-base md:text-lg text-slate-600 leading-relaxed"
          >
            In's Mercato è una delle principali insegne hard discount italiane, con un fatturato di <strong className="text-slate-800">1,5 miliardi di euro</strong>, oltre <strong className="text-slate-800">4.200 dipendenti</strong> e una rete di più di <strong className="text-slate-800">570 punti vendita</strong>. L'azienda è in una fase di forte espansione immobiliare, con un piano di nuove aperture che pone un vincolo operativo preciso: senza Store Manager qualificati, pronti e pienamente allineati alla cultura aziendale, i nuovi negozi rischiano di sottoperformare. La crescita della rete dipende direttamente dalla capacità di avere figure manageriali formate nel momento in cui servono.
          </p>
          <p className="mt-4 text-sm text-slate-500 leading-relaxed">
            Il progetto ha trasformato la gestione del talento da reattiva a predittiva, collegando direttamente la people strategy al piano di espansione: ogni nuova apertura può ora contare su una pipeline interna di figure pronte, invece di rincorrere il fabbisogno sul mercato esterno.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
